<section class="policy-section payment-section">
    <div class="container-xl policy-container">
        
        <header class="policy-header text-center">
            <h1 class="policy-title">Payment Terms & Conditions</h1>
        </header>

        <article class="policy-content">
            
            <div class="payment-rules-block">
                <h2 class="policy-heading">General Payment & Compliance Rules</h2>
                <ul class="general-rules-list">
                    <li>
                        <span class="rule-number">1.</span> Accepted Currency and Cards: Visa or MasterCard debit and credit cards in AED (UAE Dirham) will be accepted for payment.
                    </li>
                    <li>
                        <span class="rule-number">2.</span> International Compliance: We will not trade with or provide any services to OFAC (Office of Foreign Assets Control) and sanctioned countries in accordance with the law of UAE.
                    </li>
                    <li>
                        <span class="rule-number">3.</span> Age Restriction: Customers using the website who are Minor / under the age of 18 shall not register as a User of the website and shall not transact on or use the website.
                    </li>
                    <li>
                        <span class="rule-number">4.</span> Record Keeping: The Cardholder must retain a copy of transaction records and Merchant policies and rules.
                    </li>
                    <li>
                        <span class="rule-number">5.</span> Account Confidentiality: The User is responsible for maintaining the confidentiality of their account.
                    </li>
                </ul>
            </div>

            <div class="policy-details-block">
                <h2 class="policy-heading">Subscription Policy Details</h2>
                
                <div class="policy-item confirm-policy">
                    <h3 class="policy-subheading">
                        <i class="fas fa-receipt me-2"></i> Payment Confirmation
                    </h3>
                    <p class="text-color">The receipt of the payment confirmation will be shared to the registered email ID, soon after realization of the amount (within 24 hours).</p>
                </div>
                
                <div class="policy-item cancellation-policy">
                    <h3 class="policy-subheading">
                        <i class="fas fa-times-circle me-2"></i> Cancellation Policy
                    </h3>
                    <p class="text-color">Direkt.ae operates on subscription models. No cancellation is applicable after making the payment for the subscription. Clients can, however, choose not to renew the subscription upon expiry of the existing term.</p>
                </div>
                
                <div class="policy-item refund-policy">
                    <h3 class="policy-subheading">
                        <i class="fas fa-wallet me-2"></i> Refund Policy
                    </h3>
                    <p class="text-color">Direkt.ae operates on subscription-based models. No refund will be applicable on making payment for a subscription. Clients can, however, choose not to renew the subscription upon expiry of the existing term.</p>
                </div>

            </div>
            
        </article>
    </div>
</section>